import { PHONE_TYPE } from 'utils/constants';
import { Countries } from './schema';
import { GlobeIcon, PhoneIcon } from 'lucide-react';

export const countries = [
    {
        label: 'United States',
        value: Countries.US,
    },
];

export const options = [
    { label: PHONE_TYPE.LOCAL, icon: <PhoneIcon className='mb-3 h-6 w-6' /> },
    { label: PHONE_TYPE.TOLL_FREE, icon: <GlobeIcon className='mb-3 h-6 w-6' /> },
];

export const fields = [
    {
        name: 'legalBusinessName',
        label: 'Legal Business Name',
        placeholder: 'Enter your legal business name',
    },
    {
        name: 'companyWebsite',
        label: 'Company Website',
        placeholder: 'https://www.example.com',
    },
    {
        name: 'companyRegisterNumber',
        label: 'Company Register Number',
        placeholder: 'Enter your Company Register Number',
    },
    {
        name: 'street',
        label: 'Street',
        placeholder: 'Enter your Company Street',
    },
    {
        name: 'city',
        label: 'City',
        placeholder: 'Enter your Company city',
    },
    {
        name: 'region',
        label: 'Region',
        placeholder: 'Enter your Company region',
    },
    {
        name: 'postalCode',
        label: 'Postal Code',
        placeholder: 'Enter your Company postal code',
    },
];

export const canadaAndAustraliaFields = [
    {
        name: 'businessAddress',
        label: 'Business Address',
        placeholder: 'Enter your Business Address',
    },
    {
        name: 'street',
        label: 'Street',
        placeholder: 'Enter your Company Street',
    },
    {
        name: 'city',
        label: 'City',
        placeholder: 'Enter your Company city',
    },
    {
        name: 'region',
        label: 'Region',
        placeholder: 'Enter your Company region',
    },
    {
        name: 'postalCode',
        label: 'Postal Code',
        placeholder: 'Enter your Company postal code',
    },
];
